import { GoogleMapsEvent, Polygon, ILatLng } from "@ionic-native/google-maps";
import { MapProvider } from "./map";
import { PolygonUtil } from "./polygon-util";

export class PolygonEvents {

    private _polygonUtil: PolygonUtil = new PolygonUtil();


    constructor(private _polygon: Polygon, private _map: MapProvider) {

    }

    onPolygonClick(eventPolygon: (points: ILatLng[], polygon: Polygon) => void, contents?: string) {

        this._polygon.on(GoogleMapsEvent.POLYGON_CLICK).subscribe((param) => {
            this._map.closeTooltip();

            if (contents) {
                let centerPolygon: ILatLng = this._polygonUtil.findPolygonCenter(param[1]);

                this._map.openTooltip(contents, centerPolygon);
            }

            eventPolygon(param[0], param[1]);

        });

        return this;
	}
	
	getPolygon() {
		return this._polygon;
	}
}